import { Button, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { Loading } from "../../../components/Loading";
import { Note } from "../../../components/Note";
import {
  checkValidEngNumbers,
  getCities,
  onChangeProvince,
} from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";
const { Option } = Select;

const EditCar = (props) => {
  const {
    data,
    editState,
    setEditState,
    isModalOpen,
    setIsModalOpen,
    showManuFactoringYearsByCarModel,
    provinces,
    cities,
    setCities,
    models,
    setModels,
    carTypes,
    usage,
    capacity_unit,
    year_range,
    brands,
    setBrands,
    getCarsBrands,
    getCarsModels,
    onEditCar,
  } = props;
  const [isAllListFull, setIsAllListFull] = useState(true);

  useEffect(() => {
    if (isModalOpen && data) {
      if (data.province.id) {
        getCities(data.province.id).then((response) => {
          if (response.success) {
            setCities(response.data);
          } else {
            Note.error(response.message);
          }
        });
      }

      if (data.car.type) {
        getCarsBrands(data.car.type);
      }

      if (data.car.brand_id) {
        getCarsModels(data.car.brand_id);
      }

      setEditState({
        car_type: data.car.type,
        brand: data.car.brand_id,
        province_id: data.province.id,
        city_id: data.city.id,
        car_id: data.car.id,
        year: data.year,
        capacity: data.capacity || null,
        capacity_unit: data.capacity_unit || null,
        usage: data.usage || null,
        vin: data.vin || null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, data]);

  useEffect(() => {
    if (brands.length && models.length && cities.length) {
      setIsAllListFull(false);
    }
  }, [brands.length, models.length, cities.length]);

  return (
    <Modal
      open={isModalOpen}
      title="Edit Car"
      destroyOnClose
      onCancel={() => {
        setIsModalOpen(false);
        setEditState({
          car_type: null,
          brand: null,
          province_id: null,
          city_id: null,
          car_id: null,
          year: null,
          capacity: null,
          capacity_unit: null,
          usage: null,
          vin: null,
        });
        setBrands([]);
        setCities([]);
        setModels([]);
      }}
      closeIcon={
        <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
      }
      closable={true}
      footer={false}
    >
      <Loading isLoading={isAllListFull}>
        <FormWrapper>
          <Select
            className="border-black-8 "
            placeholder="Car Type"
            onChange={(value) => {
              setEditState({
                ...editState,
                car_type: value,
                brand: null,
                car_id: null,
              });
              getCarsBrands(value);
            }}
            value={editState.car_type}
          >
            {carTypes.map((carType) => {
              return (
                <Option value={carType[0]} name={carType[0]}>
                  {carType[1]}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8 "
            placeholder="Brand"
            onChange={(value) => {
              setEditState({
                ...editState,
                brand: value,
                car_id: null,
                year: null,
              });
              getCarsModels(value);
            }}
            disabled={!editState.car_type || !brands.length}
            value={editState.brand}
          >
            {brands.map((brand) => {
              return (
                <Option key={brand.id} value={brand.id}>
                  {brand.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8 "
            placeholder="Model"
            disabled={!editState.brand || !models.length}
            onChange={(value) =>
              setEditState({ ...editState, car_id: value, year: null })
            }
            value={editState.car_id}
          >
            {models.map((model) => {
              return (
                <Option key={model.id} value={model.id}>
                  {model.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8 "
            disabled={!editState.car_id}
            placeholder="Year"
            onChange={(value) => setEditState({ ...editState, year: value })}
            value={editState.year}
          >
            {showManuFactoringYearsByCarModel(
              models.find((model) => model.id === editState.car_id),
              year_range
            ).map((year, ydx) => {
              return (
                <Option key={ydx} value={year}>
                  {year}
                </Option>
              );
            })}{" "}
          </Select>
          <Select
            className="border-black-8 "
            placeholder="Province"
            onChange={(value) =>
              onChangeProvince(
                value,
                () =>
                  setEditState({
                    ...editState,
                    province_id: value,
                    city_id: null,
                  }),
                setCities
              )
            }
            value={editState.province_id}
          >
            {provinces.map((province) => {
              return <Option value={province.id}>{province.name}</Option>;
            })}
          </Select>
          <Select
            className="border-black-8 "
            placeholder="City"
            onChange={(value) => setEditState({ ...editState, city_id: value })}
            value={editState.city_id || !cities.length}
          >
            {cities.map((city) => {
              return <Option value={city.id}>{city.name}</Option>;
            })}
          </Select>
          <Select
            className="border-black-8 input-size mb-10"
            onChange={(value) => setEditState({ ...editState, usage: value })}
            value={editState.usage}
          >
            <Option value={null}>Car Usage</Option>
            {usage.map((usage) => {
              return (
                <Option key={usage[0]} value={usage[0]}>
                  {usage[1]}
                </Option>
              );
            })}
          </Select>
          <Input
            type="text"
            placeholder="Car Capacity"
            className="border-black-8 input-size mb-10"
            value={editState.capacity}
            onKeyDown={checkValidEngNumbers}
            onChange={(e) =>
              setEditState({ ...editState, capacity: e.target.value })
            }
          />
          <Select
            className="border-black-8 input-size mb-10"
            onChange={(value) =>
              setEditState({ ...editState, capacity_unit: value })
            }
            placeholder="Capacity Unit"
            value={editState.capacity_unit}
          >
            <Option value={null}>Capacity Unit</Option>
            {capacity_unit.map((capacity_unit) => {
              return (
                <Option key={capacity_unit[0]} value={capacity_unit[0]}>
                  {capacity_unit[1]}
                </Option>
              );
            })}
          </Select>
          <Input
            type="text"
            placeholder="VIN"
            className="border-black-8 input-size mb-10"
            value={editState.vin}
            onChange={(e) =>
              setEditState({ ...editState, vin: e.target.value })
            }
          />
          <Button
            className="button-secondary w-100 "
            onClick={() =>
              onEditCar(data.id, () => {
                setIsModalOpen(false);
              })
            }
          >
            Edit
          </Button>
        </FormWrapper>
      </Loading>
    </Modal>
  );
};

export default EditCar;
